import * as yup from 'yup';
import i18n from 'i18n';

export const loginSchema = yup.object().shape({
  companyEmail: yup
    .string()
    .email(() => i18n.t('website:auth.login.validation.emailInvalid'))
    .required(() => i18n.t('website:auth.login.validation.emailRequired')),
  password: yup.string().required(() => i18n.t('website:auth.login.validation.passwordRequired')),
});
